import { render, staticRenderFns } from "./egoodslist.vue?vue&type=template&id=3e5f6a06&scoped=true&"
import script from "./egoodslist.vue?vue&type=script&lang=js&"
export * from "./egoodslist.vue?vue&type=script&lang=js&"
import style0 from "./egoodslist.vue?vue&type=style&index=0&id=3e5f6a06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f6a06",
  null
  
)

export default component.exports